import { ChevronRight } from 'lucide-react';
import { Link } from 'react-router-dom';

export interface Crumb { label: string; to?: string }

/** Storefront breadcrumb trail. The last crumb is the current page (no link). */
export function Breadcrumbs({ items }: { items: Crumb[] }): JSX.Element {
  return (
    <nav aria-label="Breadcrumb" className="flex flex-wrap items-center gap-1 text-sm text-fg-muted">
      {items.map((c, i) => (
        <span key={`${c.label}-${i}`} className="inline-flex items-center gap-1">
          {i > 0 && <ChevronRight className="h-3.5 w-3.5 text-fg-subtle rtl:rotate-180" aria-hidden />}
          {c.to && i < items.length - 1 ? (
            <Link to={c.to} className="transition hover:text-fg">{c.label}</Link>
          ) : (
            <span className={i === items.length - 1 ? 'text-fg' : undefined} aria-current={i === items.length - 1 ? 'page' : undefined}>{c.label}</span>
          )}
        </span>
      ))}
    </nav>
  );
}
